import { Box } from '@mui/system';
import styled from '@mui/system/styled';
import CustomButton from 'components/Button/CustomButton';

export const ContentCnt = styled('div')({
  padding: '0',
  '& ul': {
    paddingLeft: '24px',
    marginTop: '8px',
  },
});

// Custom styled components
export const ThresholdContainer = styled(Box)(({ theme }) => ({
  padding: '20px',
}));

export const ThresholdHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '16px',
  padding: '12px 0',
  backgroundColor: '#f0f0f0',
  borderRadius: '4px',
  marginBottom: '16px',
  '& p': {
    fontWeight: 700,
    fontSize: '14px',
    color: '#000000',
  },
}));

export const ThresholdRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
  padding: '8px 0',
  '&:hover': {
    backgroundColor: '#F5F5FF',
  },
}));

export const ColorPickerContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  cursor: 'pointer',
  padding: '4px 8px',
  borderRadius: '6px',
  border: '1px solid #E0E0E0',
  width: '60px',
  height: '36px',
  '&:hover': {
    backgroundColor: '#F5F5F5',
  },
}));

export const ColorSquare = styled(Box)(({ theme }) => ({
  width: 24,
  height: 24,
  borderRadius: '4px',
}));

export const ColorDot = styled(Box)(({ theme }) => ({
  width: 36,
  height: 36,
  borderRadius: '8px',
  cursor: 'pointer',
  border: '1px solid #E0E0E0',
  transition: 'all 0.2s ease',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    transform: 'scale(1.05)',
  },
}));

export const AddThresholdButton = styled(CustomButton)(({ theme }) => ({
  backgroundColor: '#F5F5FF',
  border: '1px solid #CCCBFF',
  color: '#4E48FA',
  borderRadius: '6px',
  padding: '12px',
  textTransform: 'none',
  justifyContent: 'flex-start',
  '&:hover': {
    backgroundColor: '#e8eaff',
  },
}));

export const DragHandle = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  cursor: 'grab',
  color: '#9e9e9e',
  '&:hover': {
    color: '#616161',
  },
}));
